module.exports = __webpack_public_path__ + "static/img/we_banner.89ce6fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/we_banner.png
// module id = qvzi
// module chunks = 0